module.exports = __webpack_public_path__ + "img/top.1e40660.png";